import { z } from 'zod';

const snackbarConfigurationSchema = z.object({
  type: z.enum(['primary', 'success', 'error', 'warning', 'info']),
  translationKey: z.string(),
  translationInterpolationParameters: z
    .record(z.string(), z.string())
    .optional(),
  priority: z.number().optional(),
  canBeDismissed: z.boolean().optional(),
});

export type SnackbarConfiguration = z.infer<typeof snackbarConfigurationSchema>;

export const enqueueSnackbarConfigurationSchema =
  snackbarConfigurationSchema.omit({
    type: true,
  });

export type EnqueueSnackbarConfiguration = z.infer<
  typeof enqueueSnackbarConfigurationSchema
>;
